import { useAuth } from '@/features/auth'
import { useWorkspace } from '@/features/workspace'
import { useSpEditorProvider } from '../SpEditorProvider'
import { KEYS } from '@/components/custom/editor/stringKeys/StringKeys'

export const scriptCSSCommon = 'font-script text-[16px]'

const SpPrintPdfContent = () => {
    const { project } = useWorkspace()
    const { user } = useAuth()
    const { htmlString } = useSpEditorProvider()
    return (
        <div id={KEYS.SP_PDF_CONTENT} style={{ display: 'none' }}>
            <div className={`${scriptCSSCommon}`}>
                {/* Title Page */}
                <div className="h-screen flex flex-col justify-center items-center text-center bg-white">
                    <h1 className="text-5xl font-bold tracking-wide mb-6">{project?.title}</h1>
                    {user?.displayName && (
                        <>
                            <p className="text-2xl">by</p>
                            <p className="text-3xl mt-2 font-script">{user?.displayName}</p>
                        </>
                    )}
                </div>

                <div className="page-break-print" />

                {/* Render Lexical HTML */}
                <div
                    className={`${scriptCSSCommon} flex flex-col outline-none items-center p-4 pt-15 pb-32`}
                    dangerouslySetInnerHTML={{ __html: htmlString }}
                />
            </div>
        </div>
    )
}

export default SpPrintPdfContent
